import {
    Action,
    DataContainer,
    Feature,
    MiniAction,
    submitMerge,
    submitMiniAction,
    submitMove,
    trackOnNextPageImpression
} from "@otto-ec/tracking-bct";
import {TrackingFeatureStatus} from "./types";

export class TrackingService {

    sendInitialLoadedTrackingEvent(featureOrder: number, brandImageId: string, targetPSRBrand: string, meta_labels: DataContainer, tile_meta_labels: DataContainer, masFeatureTrackingLabels: DataContainer) {
        const trackingFeatures = [this.createTopBrandPromoTrackingFeature(featureOrder, "loaded", masFeatureTrackingLabels, meta_labels)];
        trackingFeatures.push(this.createTopBrandPromoTileTrackingFeature("loaded", brandImageId, targetPSRBrand, tile_meta_labels));
        submitMerge({}, trackingFeatures);
    }

    sendVisibleTrackingEvent() {
        const topBrandPromoFeatureMiniAction = this.createTopBrandPromoFeatureMiniAction()
        const topBrandPromoTileFeatureMiniAction = this.createTopBrandPromoTileFeatureMiniAction()
        submitMiniAction([topBrandPromoFeatureMiniAction, topBrandPromoTileFeatureMiniAction]);
    }

    sendClickTrackingEvent(featureOrder: number, brandImageId: string, targetPSRBrand: string, meta_labels: DataContainer, tile_meta_labels: DataContainer, masFeatureTrackingLabels: DataContainer, masNextPiTrackingLabels: DataContainer) {
        const featureTrackingData: Action = {
            name: "click",
            features: [
                this.createTopBrandPromoTrackingFeature(featureOrder, "clicked", masFeatureTrackingLabels, meta_labels),
                this.createTopBrandPromoTileTrackingFeature("clicked", brandImageId, targetPSRBrand, tile_meta_labels)]
        }
        const wkTrackingData: DataContainer = this.createWkTrackingData(tile_meta_labels)
        submitMove(wkTrackingData, featureTrackingData);
        const existingNextPiTrackingLabels = {'promo_Click': ['TopBrandPromo']}
        const nextPiTrackingLabels =  {
            ...existingNextPiTrackingLabels,
            ...masNextPiTrackingLabels
        }
        trackOnNextPageImpression(nextPiTrackingLabels);
    }


    private createWkTrackingData(tile_meta_labels: DataContainer): DataContainer {
        return {
            "wk.promo_AttributionFeature": ["TopBrandPromo_Storefront"],
            "wk.promo_AttributionSource": tile_meta_labels.tsl_Source? tile_meta_labels.tsl_Source : ["TopBrandPromo"],
        }
    }


    private createTopBrandPromoTrackingFeature(featureOrder: number, status: TrackingFeatureStatus, masFeatureTrackingLabels: DataContainer, meta_labels: DataContainer): Feature {
        return {
            id: "ft3_tbp",
            position: featureOrder,
            name: "TopBrandPromo",
            status: status,
            labels: {
                ...masFeatureTrackingLabels,
                promo_Feature: ["true"],
                promo_FeatureNumber: ["1"],
                promo_FilledSlots: ["1"],
                promo_TeslaModel: meta_labels.TeslaModel
            }
        }
    }

    private createTopBrandPromoTileTrackingFeature(status: TrackingFeatureStatus, brandImageId: string, targetPSRBrand: string, meta_labels: DataContainer): Feature {
        return {
            id: "ft3_tbp_tile0",
            status: status,
            name: "TopBrandPromo-Tile",
            parentId: "ft3_tbp",
            labels: {
                ...meta_labels,
                promo_Source: meta_labels.tsl_Source,
                promo_BrandImageId: [brandImageId],
                promo_TargetPSRBrand: [targetPSRBrand]
            }
        }
    }

    private createTopBrandPromoFeatureMiniAction(): MiniAction {
        return {
            featureId: `ft3_tbp`,
            action: "scroll"
        }
    }

    private createTopBrandPromoTileFeatureMiniAction(): MiniAction {
        return {
            featureId: `ft3_tbp_tile0`,
            action: "scroll"
        }
    }
}